// @flow
import PropTypes from 'prop-types'
import { compose, setPropTypes } from 'recompose'
import SearchResultsCharities from '../../ui/views/search-results-charities'
import withEntity from '../../context/with-entity'

const withPropTypes = setPropTypes({
  entities: PropTypes.array.isRequired
})

const SearchResultsCharitiesEnhancer = compose(withEntity, withPropTypes)

export default SearchResultsCharitiesEnhancer(SearchResultsCharities)



// WEBPACK FOOTER //
// ./src/services/search-results/SearchResultsCharities.js